"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordForm = void 0;
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var Yup = __importStar(require("yup"));
var YellowButton_1 = require("@app/components/controls/YellowButton");
var validationSchema = Yup.object().shape({
    email: Yup.string().trim().required('Please enter your email')
});
var ForgotPasswordForm = function (props) {
    var touched = props.touched, errors = props.errors;
    return (react_1.default.createElement(formik_1.Form, null,
        react_1.default.createElement("p", { className: "is-6 has-text-centered" }, "That's Ok!"),
        react_1.default.createElement("p", { className: "is-6 has-text-centered" }, "Click \"Continue\" and we will send you a link to reset your password."),
        react_1.default.createElement("div", { className: "field" },
            react_1.default.createElement(formik_1.Field, { name: "email", type: "text", className: "input", disabled: true }),
            touched.email && errors.email &&
                react_1.default.createElement("p", { className: "is-danger help", "data-test": "email-error" }, errors.email)),
        react_1.default.createElement(YellowButton_1.YellowButton, { type: "submit", className: "button-large", isFullWidth: true },
            react_1.default.createElement("span", { className: "icon" },
                react_1.default.createElement("i", { className: "fas fa-arrow-right" })),
            react_1.default.createElement("span", null, "Continue"))));
};
exports.ForgotPasswordForm = ForgotPasswordForm;
exports.default = formik_1.withFormik({
    validationSchema: validationSchema,
    mapPropsToValues: function (props) {
        return {
            email: props.email || ''
        };
    },
    handleSubmit: function (values, bag) {
        bag.props.onSubmit(values.email.trim());
    }
})(exports.ForgotPasswordForm);
